import axios from "./axiosInstance";
import { api } from "./api_route";

// PDF Operations (Stateless / Temporary flow)
export const uploadPDF_api = async (formData) => {
  try {
    const result = await axios.post(`${api}/api/pdf/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return result.data;
  } catch (error) {
    console.error("uploadPDF_api error:", error);
    return { error: error.response?.data?.message || error.message };
  }
};

export const detectPlaceholders_api = async (identifier) => {
  try {
    const payload =
      typeof identifier === "object"
        ? identifier
        : { tempDocId: identifier, signatureID: identifier };
    const result = await axios.post(`${api}/api/pdf/detect-placeholders`, payload);
    return result.data;
  } catch (error) {
    console.error("detectPlaceholders_api error:", error);
    return { error: error.response?.data?.message || error.message };
  }
};

export const verifySignature_api = async (identifier) => {
  try {
    const payload =
      typeof identifier === "object"
        ? identifier
        : { signedDocId: identifier, signatureID: identifier };
    const result = await axios.post(`${api}/api/sign/verify`, payload);
    return result.data;
  } catch (error) {
    console.error("verifySignature_api error:", error);
    return { error: error.response?.data?.message || error.message };
  }
};

// Audit logs removed (Stateless flow)
export const getAuditLogs_api = async () => {
  return { message: "success", data: [] };
};

// Cancel Session & purge temporary files (FR-1.3)
export const cancelSession_api = async (sessionId) => {
  try {
    const payload = typeof sessionId === "object" ? sessionId : { sessionId };
    const result = await axios.post(`${api}/api/pdf/cancel`, payload);
    return result.data;
  } catch (error) {
    console.error("cancelSession_api error:", error);
    return { error: error.response?.data?.message || error.message };
  }
};
